<template>
  <div class="app-container">
    <div class="container-title">
      <img src="../../assets/images/lightAnalysis/container-title.png" alt="">
    </div>
    <div class="applyBtn-container">
      <img src="../../assets/images/lightAnalysis/apply-button.png" alt="" @click="show = true">
    </div>
    <van-action-sheet class="apply-actionSheet" v-model="show" title="数字驾驶舱内测申请">
      <div :class="['content', { 'long-content': companyNameInputFocus || phoneInputFocus}]">
        <div class="input-group">
          <div class="group-item">
            <input type="text" :class="['form-input', 'companyName-input', {'input-focus': companyNameInputFocus}]" v-model="companyName" @focus="handleCompanyNameInputFocus" @blur="handleCompanyNameInputBlur">
            <div :class="['input-placeholder', {'placeholder-focus': companyNameInputActive}]">请输入已开通账无忧5.0服务的公司名称</div>
          </div>
          <div class="group-item phoneNumber-group">
            <input type="text" :class="['form-input', 'phoneNumber-input', {'input-focus': phoneInputFocus}]" v-model="phoneNumber" @focus="handlePhoneInputFocus" @blur="handlePhoneInputBlur">
            <div :class="['input-placeholder', {'placeholder-focus': phoneInputActive}]">请输入账无忧5.0的登录手机号码</div>
          </div>
        </div>
        <div :class="['submit-btn', {'isActive': isSubmitActive}]" @click="handleSubmitBtnClick">提交申请</div>
      </div>
    </van-action-sheet>
    <van-dialog v-model="showSubmitSuccessDialog" :confirm-button-color="'#1C2734'">
      <div class="successDialog-content">
        <p><img v-if="showSubmitSuccessDialog" class="success-gif" src="../../assets/images/sucess.gif" alt="" /></p>
        <p class="successDialog-content-title">提交成功</p>
        <p>相关工作人员正在审批中</p>
        <p>审批通过后将会短信或电话方式通知您</p>
        <p>敬请留意</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { ActionSheet, Toast, Dialog } from 'vant'
import axios from 'axios'
Vue.use(ActionSheet).use(Toast).use(Dialog)

export default {
  name: 'lightAnalysis',
  data () {
    return {
      show: false,
      companyName: '',
      companyNameInputFocus: false,
      companyNameInputActive: false, // 输入框是否为激活状态，与focus区分
      phoneNumber: '',
      phoneInputFocus: false,
      phoneInputActive: false,
      showSubmitSuccessDialog: false // 是否显示提交成功后的弹框
    }
  },
  computed: {
    isSubmitActive () { // 按钮是否处于激活状态
      return this.companyName !== '' && this.phoneNumber !== ''
    }
  },
  methods: {
    handleCompanyNameInputFocus () {
      this.companyNameInputFocus = true
      this.companyNameInputActive = true
    },

    handleCompanyNameInputBlur () {
      if (!this.companyName) {
        this.companyNameInputActive = false
      }
      this.companyNameInputFocus = false
    },

    handlePhoneInputFocus () {
      this.phoneNumber = this.phoneNumber.replace(/-/g, '')
      this.phoneInputFocus = true
      this.phoneInputActive = true
    },

    handlePhoneInputBlur () {
      if (!this.phoneNumber) {
        this.phoneInputActive = false
      }
      this.phoneInputFocus = false
      this.formatPhoneNumber()
    },

    validatePhoneNumber(tel) {
      let phone = /^1[3|4|5|6|7|8|9]\d{9}$/
      return phone.test(tel)
    },

    formatPhoneNumber () {
      const phoneNumber = this.phoneNumber
      if (!this.validatePhoneNumber(phoneNumber)) {
        Toast('请输入正确的手机号码')
        return
      }

      let formatStr = ''
      for (let i = 0; i < phoneNumber.length; i ++) {
        formatStr += phoneNumber[i]
        if (i === 2 || i === 6) {
          formatStr += '-' 
        }
      }
      this.phoneNumber = formatStr
    },

    // 提交申请按钮被点击
    handleSubmitBtnClick () {
      if (!this.isSubmitActive) {
        return
      }
      let { phoneNumber } = this
      phoneNumber = phoneNumber.replace(/-/g, '')
      if (!this.validatePhoneNumber(phoneNumber)) {
        Toast('请输入正确的手机号码')
        return
      }
      const param = {
        applyName: this.companyName,
        applyPhone: phoneNumber
      }
      axios.post('/fc/small/program/add/applyinfo', param).then(res => {
        const { code } = res.data
        if (code === 200) {
          this.showSubmitSuccessDialog = true
        } else {
          Toast('网络异常，请稍后再试')
        }
      }, err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.app-container
  position relative
  width 100%
  height 100%
  background-image url('../../assets/images/lightAnalysis/lightAnalysis-bg.png')
  background-position center center !important
  background-repeat no-repeat !important
  background-size cover !important
  .container-title
    text-align center
    img
      width 75%
      margin-top 0.495rem
  .applyBtn-container
    position absolute
    width 100%
    text-align center
    bottom 0.32rem
    img
      width 76%
  .apply-actionSheet
    >>> .van-action-sheet__header
      height 0.56rem
      line-height 0.56rem
      background-color #EEF9FF
      color #1C2734
      font-size 0.24rem
    .content
      height 3.605rem
      overflow hidden
      transition-delay 50ms
      transition-property height
      transition-duration 200ms
      transition-timing-function linear
      .input-group
        margin 0.37rem 0.375rem 0 0.375rem
        .group-item
          position relative
          height 0.5rem
          .form-input
            position absolute
            top 0.2rem
            z-index 1
            width 100%
            height 0.23rem
            border none;
            border-bottom 0.005rem solid #DDE1E5
            border-radius 0
            font-size 0.17rem
            font-weight 500
            background-color rgba(0, 0, 0, 0)
            padding 0 0 0.03rem 0
          .phoneNumber-input
            // font-weight 700
          .input-placeholder
            position absolute
            top 0.16rem
            color #92979E
            font-size 0.17rem
            z-index 0
            transition-delay 50ms
            transition-property font-size, top
            transition-duration 200ms
            transition-timing-function linear
          .input-focus
            border-color #1390ff
          .placeholder-focus
            top 0
            font-size 0.13rem
            transition-delay 50ms
            transition-property font-size,top
            transition-duration 200ms
            transition-timing-function linear
        .group-item.phoneNumber-group
          margin-top 0.38rem
          font-size 0.18rem
      .submit-btn
        width 3rem
        height 0.56rem
        line-height 0.56rem
        text-align center
        margin 0.6rem 0.375rem
        background-color #DDE1E5
        color #92979E
        box-shadow 0 0.1rem 0.2rem 0 rgba(28, 39, 52, 0.1)
        border-radius 0.56rem
        font-size 0.17rem
      .isActive
        border-color #0078E2
        color #ffffff
        background-color #1390FF
        box-shadow 0 0.1rem 0.2rem 0 rgba(19, 144, 255, 0.2)
    .long-content
      height 4.7rem
      transition-delay 50ms
      transition-property height
      transition-duration 200ms
      transition-timing-function linear
  .successDialog-content
    width 100%
    border-bottom 1px solid #DDE1E5
    padding-bottom 0.2rem
    p
      color #92979E
      text-align center
      margin 0
      font-size 0.12rem
      line-height 0.16rem
      .success-gif
        width 0.44rem
        margin-top 0.3rem
    .successDialog-content-title
      font-size 0.17rem
      color #1C2734
      line-height 0.255rem
      font-weight 700
      margin-bottom 0.1rem
</style>